module.exports = __webpack_public_path__ + "img/11_Tennseite_Drehschieben@2x.16c20549.jpg";